import { AxiosResponse } from "axios";
import { ILogin } from "../../interfaces/api";
import HTTP from "../../services/http.service";

export function getToken(params: ILogin): Promise<AxiosResponse<any>> {
    const payload: any = `grant_type=password&username=${encodeURIComponent(params.username)}&password=${encodeURIComponent(params.password)}`;
    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Organization: params.orgShortName,
        Authorisation: null,
    };

    return HTTP.post(`/token`, payload, {headers});
}
